import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiperElement = document.querySelector<HTMLElement>(
    '[data-top-feature-swiper]'
  );

  if (swiperElement) {
    new Swiper(swiperElement, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 16,
      loop: true,
      speed: 3000,
      navigation: {
        nextEl: '[data-top-feature-swiper-next]',
        prevEl: '[data-top-feature-swiper-prev]',
      },
      pagination: {
        el: '[data-data-top-feature-swiper-pagination]',
        type: 'bullets',
        clickable: true,
        bulletClass: 'global-swiper-pagination__bullet',
        bulletActiveClass: 'global-swiper-pagination__bullet--active',
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
    });
  }
});
